module.exports = __webpack_public_path__ + "img/Majaal_blue.94d005c5.png";